/**
 * This module is responsible for triggering the "Get Support Typeform" as a modal.
 * Important: It doesn't only trigger the modal, it also sends a request to the DF Platform,
 * creating a new user.
 */

(function ($) {
  $(window).ready(function () {

    const UTMs = window.dfApi.getLocalStorage(window.dfCONSTANTS.localstorage.utmParams) ?? {};

    /**
     * Responsible for making a request to the platform
     * @param {object} params - the url params for window.dfPlatform.createAnonymousUser
     * @param {jQuery} $linkElement - the link to update with the type form ID
     */
    function makePlatformRequest(params, $linkElement) {
      // Create an anonymous user
      window.dfPlatform.createAnonymousUser(params)
        .then(values => {
          if(values.healthtxt_message && values.healthtxt_message.code === "0"){

            // Add login id param to url
            const loginIdHex = values.healthtxt_message.message_body.Login.login_id.toString(16);
            const typeFormURL = values.healthtxt_message.message_body.Login.typeform_url + '?a=44&z=' + loginIdHex;

            // Create the popup
            const popup = window.typeformEmbed.makePopup(
              typeFormURL,
              {
                mode: "popup",
                hideFooter: true,
                hideHeaders: true,
                hideScrollbars: true,
                onSubmit: () => {
                  // Form will automatically redirect to the proper URL on the site.
                }
              }
            );

            // Open the popup
            popup.open();

          }
        })
        .catch((error) => {
          console.error(error);
        });

    }

    // Trigger Get Support Typeform modal on the "Get Support Create User" module
    $(".get-support-create-user-button").on("click", function (e) {
      e.preventDefault();
      const $element = $(this);
      const language = $element.data('language') ?? 'EN';

      const guid = window.dfApi.uuidv4();

      window.dfApi.updateLocalStorage(window.dfCONSTANTS.localstorage.uuid, guid);

      // Create the params for the platform
      const params = {
        p1: guid,
        p2: 'vgFP89AJ7bX9KW5p',
        p3: language,
        p4: 'LovedOne',
        utm_source: UTMs['utm_source'] ?? '',
        utm_medium: UTMs['utm_medium'] ?? '',
        utm_campaign: UTMs['utm_campaign'] ?? '',
        utm_term: UTMs['utm_term'] ?? '',
      };

      makePlatformRequest(params, $element);
    });

    // Typeform widget include
    (function () {
      let qs, js, q, s, d = document, gi = d.getElementById, ce = d.createElement, gt = d.getElementsByTagName,
        id = "typef_orm_share", b = "https://embed.typeform.com/";
      if (!gi.call(d, id)) {
        js = ce.call(d, "script");
        js.id = id;
        js.src = b + "embed.js";
        q = gt.call(d, "script")[0];
        q.parentNode.insertBefore(js, q)
      }
    })()

  });
})(jQuery);
